import { executeRequest, JFSRequest } from '@jfs/network'

import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'
const responseParser = (response: any) => {
  return response.data.data.token
}
const generateSupersetGuestTokens = (merchantId: string, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: APIEndPoints.generateSupersetGuestTokens,
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    body: { merchantId },
  }
  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}
export { generateSupersetGuestTokens }
